import { render, staticRenderFns } from "./EmbedHeaderViewButtons.vue?vue&type=template&id=b6a0c6d8&"
import script from "./EmbedHeaderViewButtons.vue?vue&type=script&lang=js&"
export * from "./EmbedHeaderViewButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports